import type { AuthUser } from '../reducers/auth';
import type { RootState } from '../types';

import { useSelector } from 'react-redux';

import { Api } from '../api';
import { useClientData } from '../contexts';

export { default as useCopy } from './use-copy';
export { default as useInterval } from './use-interval';
export { default as useMediaQuery } from './use-media-query';
export { default as useNow } from './use-now';

/**
 * Access the auth.user
 *
 * NB: Only use this in parts of the tree you are sure will have a User!  I.e.
 * under the if(auth.user) check at the root.
 */
export function useAuthUser(): AuthUser {
  const { user } = useSelector((state: RootState) => state.auth);
  if (!user) throw new Error('Called useAuthUser without being logged in');
  return user;
}

export function useMyUserClient(): Api.User.V_Self {
  const { user } = useClientData();
  if (!user)
    throw new Error('Called useMyUserClient without matching client data');
  return user;
}
